import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { styled } from '@components-shared/src/stitches';
import { NextFutureImage } from '@components/main-components/image/NextFutureImage';
import { Modal } from '@components/main-components/modals/Modal';
import { ModalContext } from '@context/modal';

export const ImageViewModal = ({ src }: { src: string }) => {
  const { closeCancelModal } = ModalContext.useContainer();
  const body = (
    <>
      {src ? (
        <NextFutureImage
          alt="Image view"
          src={src}
          fill
          style={{
            objectFit: 'contain',
          }}
        />
      ) : null}
    </>
  );

  const header = (
    <HeaderContainer>
      <IconContainer onClick={() => closeCancelModal()}>
        <FontAwesomeIcon icon={faXmark} size="lg" />
      </IconContainer>
    </HeaderContainer>
  );

  return (
    <>
      <Modal
        header={header}
        headerStyles={{ height: 0 }}
        body={body}
        bodyStyles={{ margin: 0 }}
        closeModal={closeCancelModal}
        containerStyles={{
          size: 343,
          padding: 0,
          margin: 0,
          overflow: 'visible',
          '@tablet': { size: 720 },
          '@tabletLandscape': { size: 788 },
        }}
      />
    </>
  );
};

const HeaderContainer = styled('div', {
  position: 'absolute',
  top: -10,
  right: -10,
  zIndex: '$above1',
});

const IconContainer = styled('div', {
  width: 35,
  height: 35,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: 'rgba(255, 255, 255, 0.6)',
  borderRadius: 32,
  backdropFilter: 'blur(4px)',
  cursor: 'pointer',
  '&:hover': {
    background: 'rgba(255, 255, 255, 1)',
  },
});
